import styled from 'styled-components';
import BoxContainer from 'containers/BoxContainer';
import {Container as RowContainer} from 'components/Row';
import {transparentize} from 'polished';

export const Container = styled(BoxContainer)`
  max-width: 440px;
  margin: 0 auto;
  padding: 20px 25px;
  display: grid;
`;

export const Title = styled.span`
  margin-bottom: 20px;
  line-height: 28px;
  font-weight: 600;
  font-size: 22px;
`;

export const Rows = styled.div`
  ${RowContainer} {
    padding: 6px 0;
    
    &:last-child {
      margin-top: 6px;
    }
  }
`;

export const Text = styled.p`
  margin: 14px 0;
  text-align: center;
  line-height: 18px;
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.7, theme.variables.color)};
  `};
`;

export const SocialsContainer = styled.div`
  display: grid;
  gap: 20px;
  margin: 24px 0 10px;
`;

export const SocialsTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.01em;
  text-align: center;
`;

export const SocialsList = styled.div`
  width: max-content;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(4, max-content);
  gap: 20px;
`;
